import styled from 'styled-components';
import { themeGet, getTextColor, getPaletteColor } from '@magalu/stereo-ui-styles';
import { Dialog, Text, Button } from '../../atoms';
import { HorizontalRule } from '../../atoms/Dialog/dialog.styles';
export const LabelTitle = styled(Text)`
  color: ${props => getTextColor('scratched')(props)};
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  margin-bottom: 5px;
`;
export const Label = styled(Text)`
  color: ${props => getTextColor('scratched')(props)};
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
`;
export const Disclaimer = styled(Text).attrs({
  fontSize: 3
})`
  line-height: normal;
  font-weight: normal;
  color: ${props => themeGet('colors.greyishBrown')(props)};
`;
export const ImportText = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-weight: normal;
  font-size: ${props => themeGet('fontSizes.3')(props)}px;

  color: ${props => themeGet('colors.greyishBrown')(props)};
  line-height: 18.7px;

  b {
    font-weight: 500;
  }
`;
export const ImportButton = styled(Button)`
  border-radius: 12px;
  padding: 11px 100px;
`;
export const Title = styled(Text)`
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  color: ${props => getPaletteColor('text.scratched')(props)};
  line-height: 1.25;
`;
export const BreakingLine = styled.br``;
export const DialogContainer = styled(Dialog).attrs({
  titleStyle: {
    fontSize: '22px',
    color: '#424A52',
    fontWeight: 700
  }
})`
  max-width: 724px;
  overflow-x: hidden;
`;
export const DialogHorizontalRule = styled(HorizontalRule)`
  height: 1px;
  max-width: 724px;
  transform: translateX(-16px);
  margin: 24px 0 18px;
`;